module.exports = __webpack_public_path__ + "static/media/Pentagon1.d7570bc4.jpg";